import type {
  AttendanceConclusion,
  CoachingQuotaLedger,
  CoachingSessionType,
  ParticipationReport,
} from '@efdigital/ll-addon-data';

export const RESOLVED_OUTCOME_LABELS: Record<AttendanceConclusion, string> = {
  attended: 'Attended',
  no_show_coachee: 'No show by coachee',
  no_show_coach: 'No show by coach',
  no_show_both: 'No show by both',
  session_void: 'Session void',
};

export const RESOLVED_OUTCOME_HELP: Record<AttendanceConclusion, string> = {
  attended:
    'Both parties attended. Writes finance lines. Does not credit quota.',
  no_show_coachee:
    'Coachee did not attend. Scheduled coaching minutes stay debited.',
  no_show_coach:
    'Coach did not attend. Credits scheduled coaching minutes back to the plan.',
  no_show_both:
    'Neither party attended. Credits scheduled coaching minutes back to the plan.',
  session_void:
    'Session did not count. Credits scheduled coaching minutes back to the plan.',
};

export const RESOLVE_OUTCOMES: AttendanceConclusion[] = [
  'attended',
  'no_show_coachee',
  'no_show_coach',
  'no_show_both',
  'session_void',
];

const PARTICIPATION_REPORT_LABELS: Record<ParticipationReport, string> = {
  session_delivered: 'Session delivered',
  i_did_not_attend: 'Reporter did not attend',
  other_did_not_attend: 'Other party did not attend',
  reported_issue: 'Reported an issue',
};

export function resolvedOutcomeLabel(outcome: AttendanceConclusion): string {
  return RESOLVED_OUTCOME_LABELS[outcome];
}

export function resolvedOutcomeHelp(outcome: AttendanceConclusion): string {
  return RESOLVED_OUTCOME_HELP[outcome];
}

export function participationReportLabel(report: ParticipationReport): string {
  return PARTICIPATION_REPORT_LABELS[report];
}

export function outcomeCreditsQuota(outcome: AttendanceConclusion): boolean {
  return (
    outcome === 'no_show_coach' ||
    outcome === 'no_show_both' ||
    outcome === 'session_void'
  );
}

export function netQuotaForSession(
  ledgers: CoachingQuotaLedger[],
  sessionType: CoachingSessionType
): number {
  return ledgers
    .filter((ledger) => ledger.sessionType === sessionType)
    .reduce((sum, ledger) => sum + ledger.amount, 0);
}
